export default __webpack_public_path__ + "static/media/halftone_mirjam.6677deee.png";